export default [
    {
        path: "/",
        meta: {
            public: true,
            nomenu: true
        },
        name: "Root",
        redirect: {
            name: "Login"
        }
    },
    {
        path: "*",
        meta: {
            public: true
        },
        redirect: {
            path: "/404"
        }
    },
    {
        path: "/404",
        meta: {
            public: true
        },
        name: "NotFound",
        component: () => import(`@/views/NotFound.vue`)
    },
    {
        path: "/403",
        meta: {
            public: true
        },
        name: "AccessDenied",
        component: () => import(`@/views/Deny.vue`)
    },
    {
        path: "/500",
        meta: {
            public: true
        },
        name: "ServerError",
        component: () => import(`@/views/Error.vue`)
    },
    {
        path: "/login/:userName?/:password?",
        meta: {
            public: true
        },
        name: "Login",
        component: () => import(`@/views/Login.vue`)
    },
    {
        path: "/forgotPassword/:userName?",
        meta: {
            public: true
        },
        name: "ForgotPass",
        component: () => import(`@/views/ForgotPassword.vue`)
    },
    {
        path: "/searchLogByPhone/:phone?",
        meta: {
            public: true
        },
        name: "ForgotPass",
        component: () => import(`@/views/admin/infoLog/SearchByPhoneLog.vue`)
    },
    {
        path: "/searchImageByPhoneOrUsername",
        meta: {
            public: true
        },
        name: "SearchImageByPhoneOrUsername",
        component: () => import(`@/views/admin/infoLog/SearchImageByPhoneOrUsername.vue`)
    },
    {
        path: "/searchImageByPhoneOrUsername2024",
        meta: {
            public: true
        },
        name: "SearchImageByPhoneOrUsername",
        component: () => import(`@/views/admin/infoLog/SearchImageByPhoneOrUsername2024.vue`)
    },
    {
        path: "/searchEventTetByPhone",
        meta: {
            public: true
        },
        name: "searchEventTet2024ByPhone",
        component: () => import(`@/views/admin/infoLog/SearchEventTet2024ByPhone.vue`)
    },
    {
        path: "/searchCoin2",
        meta: {
            public: true
        },
        name: "searchCoin2",
        component: () => import(`@/views/admin/infoLog/SearchCoin2.vue`)
    },
    {
        path: "/searchCoin",
        meta: {
            public: true
        },
        name: "searchCoin",
        component: () => import(`@/views/admin/infoLog/SearchCoin.vue`),
    },
    {
        path: "/searchCoinNew/:startDate",
        meta: {
            public: true
        },
        name: "searchCoinNew",
        component: () => import(`@/views/admin/infoLog/SearchCoinNew.vue`),
        props: route => ({
            startDate: route.params.startDate
        })
    },
    {
        path: "/searchCoinTwoWeek/:startDate",
        meta: {
            public: true
        },
        name: "searchCoinTwoWeek",
        component: () => import(`@/views/admin/infoLog/SearchCoinTwoWeek.vue`),
        props: route => ({
            startDate: route.params.startDate
        })
    },
    {
        path: "/resetPass/:verify?/:userName?",
        meta: {
            public: true
        },
        name: "ResetPass",
        component: () => import(`@/views/ResetPass.vue`)
    },
    {
        path: "/token",
        meta: {
            public: true
        },
        name: "Token",
        component: () => import(`@/views/Token.vue`)
    },
    {
        path: "/register/:username?",
        meta: {
            public: true
        },
        name: "register",
        component: () => import(`@/views/register/register.vue`)
    },
    {
        path: "/registerSuccess",
        meta: {
            public: true
        },
        name: "registerSuccess",
        component: () => import(`@/views/register/RegisterSuccess.vue`)
    },
    {
        path: "/LandingPage",
        meta: {
            public: true
        },
        name: "LandingPage",
        component: () => import(`@/views/LandingPage.vue`)
    },
    {
        path: "/HomePage", meta: {
            breadcump: true,
            public: true,
            nomenu: true,
            footer: true
        },
        name: "HomePage",
        component: () => import(`@/views/home/HomePage.vue`)
    },
    {
        path: "/TeacherPage", meta: {
            breadcump: true,
            public: false,
            nomenu: true,
            footer: true
        },
        name: "TeacherPage",
        component: () => import(`@/views/home/TeacherPage.vue`)
    },
    {
        path: "/AdminPage", meta: {
            breadcump: true,
            footer: true
        },
        name: "AdminPage",
        component: () => import(`@/views/home/AdminPage.vue`)
    },
    {
        path: "/StudentPage", meta: {
            breadcump: true,
            public: false,
            nomenu: true,
            footer: true
        },
        name: "StudentPage",
        component: () => import(`@/views/home/StudentPage.vue`)
    },
    {
        path: "/CreateClass/:classId?", meta: {
            breadcump: true,
            nomenu: true
        },
        name: "CreateClass",
        component: () => import(`@/views/class/createClass.vue`)
    },
    {
        path: "/ViewClass/:classId?/:objectType?/:objectId?/:userId?", meta: {
            breadcump: true,
            nomenu: true
        },
        name: "ViewClass",
        component: () => import(`@/views/class/classPage.vue`)
    },
    {
        path: "/savedPost", meta: {
            breadcump: true,
            nomenu: true
        },
        name: "savedPost",
        component: () => import(`@/views/class/savedPost.vue`)
    },
    {
        path: "/post/item/:postId?", meta: {
            breadcump: true,
            nomenu: true
        },
        name: "viewPost",
        component: () => import(`@/views/class/viewPost.vue`)
    },
    {
        path: "/JoinClass/:classCode?/:verify?", meta: {
            breadcump: true,
            public: false,
            nomenu: true
        },
        name: "JoinClass",
        component: () => import(`@/views/class/joinClass.vue`)
    },
    {
        path: "/user",
        meta: {breadcrumb: true},
        name: "userIndex",
        component: () => import(`@/views/user/UserList.vue`)
    },
    {
        path: "/user/list",
        meta: {breadcrumb: true},
        name: "userList",
        component: () => import(`@/views/user/UserList.vue`)
    },
    {
        path: "/userlog",
        meta: {breadcrumb: true},
        name: "userLog",
        component: () => import(`@/views/admin/UserLog.vue`)
    },
    {
        path: "/user/edit/:id?",
        meta: {breadcrumb: true},
        name: "userEdit",
        component: () => import(`@/views/user/UserEdit.vue`)
    },
    {
        path: "/profile",
        meta: {
            breadcrumb: false,
            public: false,
            nomenu: true
        },
        name: "profile",
        component: () => import(`@/views/Profile.vue`)
    },
    {
        path: "/changePass",
        meta: {
            breadcrumb: false,
            public: false,
            nomenu: true
        },
        name: "changePass",
        component: () => import(`@/views/ChangePass.vue`)
    },
    {
        path: "/changeNotify",
        meta: {
            breadcrumb: false,
            public: false,
            nomenu: true
        },
        name: "changeNotify",
        component: () => import(`@/views/ChangeNotify.vue`)
    },
    {
        path: "/role",
        meta: {breadcrumb: true},
        name: "roleIndex",
        component: () => import('@/views/role/RoleList.vue')
    },
    {
        path: "/role/list",
        meta: {breadcrumb: true},
        name: "roleList",
        component: () => import(`@/views/role/RoleList.vue`)
    },
    {
        path: "/role/edit/:id?",
        meta: {breadcrumb: true},
        name: "roleEdit",
        component: () => import(`@/views/role/RoleEdit.vue`)
    },
    {
        path: "/menu",
        meta: {breadcrumb: true},
        name: "MenuIndex",
        component: () => import(`@/views/menu/MenuList.vue`)
    },
    {
        path: "/menu/list",
        meta: {breadcrumb: true},
        name: "MenuList",
        component: () => import(`@/views/menu/MenuList.vue`)
    },
    {
        path: "/menu/edit/:id?",
        meta: {breadcrumb: true},
        name: "menuEdit",
        component: () => import(`@/views/menu/MenuEdit.vue`)
    },
    {
        path: "/formManager",
        meta: {breadcrumb: true},
        name: "formManager",
        component: () => import(`@/views/admin/form/FormList.vue`)
    },
    {
        path: "/formManager/list",
        meta: {breadcrumb: true},
        name: "formManagerList",
        component: () => import(`@/views/admin/form/FormList.vue`)
    },
    {
        path: "/workflow",
        meta: {breadcrumb: true},
        name: "workflowManager",
        component: () => import(`@/views/admin/workflow/WorkflowList.vue`)
    },
    {
        path: "/task/:processDefinitionId?",
        meta: {breadcrumb: false},
        name: "taskManager",
        component: () => import(`@/views/admin/task/TaskList.vue`)
    },
    {
        path: "/taskCompleted/:processDefinitionId?",
        meta: {breadcrumb: false},
        name: "taskCompleted",
        component: () => import(`@/views/admin/task/CompleteTaskList.vue`)
    },
    {
        path: "/search",
        meta: {breadcrumb: true},
        name: "searchFullText",
        component: () => import(`@/views/admin/search/Search.vue`)
    },
    {
        path: "/crawler",
        meta: {breadcrumb: true},
        name: "crawlerManager",
        component: () => import(`@/views/admin/search/Manager.vue`)
    },
    {
        path: "/notification",
        meta: {breadcrumb: true},
        name: "NotificationProfileList",
        component: () => import(`@/views/notification/NotificationProfileList.vue`),
    },
    {
        path: "/notification/edit/:notificationId?",
        meta: {breadcrumb: true},
        name: "NotificationProfileEdit",
        component: () => import(`@/views/notification/NotificationProfileEdit.vue`)
    },
    {
        path: "/notificationType",
        meta: {breadcrumb: true},
        name: "NotificationTypeList",
        component: () => import(`@/views/notification/NotificationTypeList.vue`),
    },
    {
        path: "/notificationType/edit/:notificationTypeId?",
        meta: {breadcrumb: true},
        name: "NotificationTypeEdit",
        component: () => import(`@/views/notification/NotificationTypeEdit.vue`)
    },
    {
        path: "/notification/activities",
        meta: {breadcrumb: true},
        name: "NotificationActivity",
        component: () => import(`@/views/notification/NotificationActivity.vue`)
    },
    {
        path: "/category",
        meta: {breadcrumb: true},
        name: "category",
        component: () => import(`@/views/admin/category/CategoryList.vue`)
    },
    {
        path: "/categoryType",
        meta: {breadcrumb: true},
        name: "categoryType",
        component: () => import(`@/views/admin/category/CategoryType.vue`)
    },
    {
        path: "/payment", meta: {
            breadcump: true,
            nomenu: true
        },
        name: "payment",
        component: () => import(`@/views/admin/UserAccount.vue`)
    },
    {
        path: "/customer",
        meta: {breadcrumb: true},
        name: "degree",
        component: () => import(`@/views/admin/category/customer/Customer.vue`)
    },
    {
        path: "/viewPresent/:id?",
        meta: {breadcrumb: true},
        name: "viewPresent",
        component: () => import(`@/views/admin/category/customer/ViewPresent.vue`)
    },
    {
        path: "/viewDocument/:id?",
        meta: {breadcrumb: true},
        name: "viewDocument",
        component: () => import(`@/views/admin/category/customer/CustomerDocument.vue`)
    },
    {
        path: "/procedure",
        meta: {breadcrumb: true},
        name: "procedure",
        component: () => import(`@/views/admin/procedure/ProcedureList.vue`)
    },
    {
        path: "/request",
        meta: {breadcrumb: true},
        name: "request",
        component: () => import(`@/views/admin/request/RequestList.vue`)
    },
    {
        path: "/files",
        meta: {breadcrumb: true},
        name: "files",
        component: () => import(`@/views/files/FileList.vue`)
    },
    {
        path: "/categorylist/envIndex",
        meta: {breadcrumb: true},
        name: "envIndex",
        component: () => import(`@/views/admin/env_index/EnvIndexList.vue`)
    },
    {
        path: "/categorylist/partner",
        meta: {breadcrumb: true},
        name: "partner",
        component: () => import(`@/views/admin/partner/PartnerList.vue`)
    },
    {
        path: "/categorylist/material",
        meta: {breadcrumb: true},
        name: "material",
        component: () => import(`@/views/admin/material/MaterialList.vue`)
    },
    {
        path: "/categorylist/pond",
        meta: {breadcrumb: true},
        name: "pond",
        component: () => import(`@/views/admin/pond/PondList.vue`)
    },
    {
        path: "/categorylist/warehouse",
        meta: {breadcrumb: true},
        name: "warehouse",
        component: () => import(`@/views/admin/warehouse/WarehouseList.vue`)
    },
    {
        path: "/categorylist/farmingProcess",
        meta: {breadcrumb: true},
        name: "farmingProcess",
        component: () => import(`@/views/admin/farming_process/FarmingProcessList.vue`)
    },
    {
        path: "/categorylist/pondArea",
        meta: {breadcrumb: true},
        name: "pondArea",
        component: () => import(`@/views/admin/pond_area/PondAreaList.vue`)
    },
    //chuongbv_add
    {
        path: "/programFrame/programlist",
        meta: {breadcrumb: true},
        name: "programlist",
        component: () => import(`@/views/admin/program/ProgramList.vue`)
    },
    {
        path: "/program/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/week/WeekList.vue`)
    },
    {
        path: "/class/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/class/ClassWeekList.vue`)
    },

    {
        path: "/liveClassPointInfo/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point/LiveClassList.vue`)
    },

    {
        path: "/categoryPointInfo/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point/CategoryPointList.vue`)
    },
    {
        path: "/feedback/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point/FeedbackList.vue`)
    },
    {
        path: "/missions/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point/MissionReviewList.vue`)
    },
    {
        path: "/partPointInfo/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point/PartPointList.vue`)
    },

    {
        path: "/liveClassPointInfoAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point_account/LiveClassList.vue`)
    },

    {
        path: "/categoryPointInfoAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point_account/CategoryPointList.vue`)
    },
    {
        path: "/feedbackAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point_account/FeedbackList.vue`)
    },
    {
        path: "/missionsAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point_account/MissionReviewList.vue`)
    },
    {
        path: "/kidMissionReview/list",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/missionReview/MissionCheckList.vue`)
    },
    {
        path: "/partPointInfoAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/point_account/PartPointList.vue`)
    },

    {
        path: "/accountDetailClass/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/account_class/AccountDetail.vue`)
    },


    {
        path: "/accountClass/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView1",
        component: () => import(`@/views/admin/account_class/AccountDetailList.vue`)
    },

    {
        path: "/account/accountList",
        meta: {breadcrumb: true},
        name: "accountList",
        component: () => import(`@/views/admin/account/AccountList.vue`)
    },

    {
        path: "/account/accountBabiList",
        meta: {breadcrumb: true},
        name: "accountBabiList",
        component: () => import(`@/views/admin/account/AccountBabiList.vue`)
    },
    {
        path: "/accountDetail/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/account/AccountDetail.vue`)
    },
    {
        path: "/logModeAccountClass/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/modeAccountClass/LogModeClassDetail.vue`)
    },
    {
        path: "/class/classlist",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/class/ClassList.vue`)
    },

    {
        path: "/class/classAccountList",
        meta: {breadcrumb: true},
        name: "classAccountList",
        component: () => import(`@/views/admin/account_class/AccountClassList.vue`)
    },

    {
        path: "/import/importClass",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportClassList.vue`)
    },
    {
        path: "/import/importBabiClass",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportBabiClassList.vue`)
    },
    {
        path: "/import/importClassZalo",
        meta: {breadcrumb: true},
        name: "classZalolist",
        component: () => import(`@/views/admin/import/ImportClassZaloList.vue`)
    },
    {
        path: "/import/importAccount",
        meta: {breadcrumb: true},
        name: "importAccount",
        component: () => import(`@/views/admin/import/ImportAccountList.vue`)
    },
    {
        path: "/import/importBabiAccount",
        meta: {breadcrumb: true},
        name: "importBabiAccount",
        component: () => import(`@/views/admin/import/ImportBabiAccountList.vue`)
    },
    {
        path: "/import/importMission",
        meta: {breadcrumb: true},
        name: "missionlist",
        component: () => import(`@/views/admin/import/ImportMissionList.vue`)
    },
    {
        path: "/import/importTutorPartPoint",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportTutorPartPointList.vue`)
    },
    {
        path: "/import/importClassBabiPro",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportClassBabiPro.vue`)
    },
    {
        path: "/import/importFreeTimeBabiPro",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportFreeTimeBabiPro.vue`)
    },
    {
        path: "/import/importTeachersBabiPro",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportTeacherBabiPro.vue`)
    },
    {
        path: "/missions/missionList",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/mission/MissionList.vue`)
    },

    {
        path: "/home",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/home/HomeInfo.vue`)
    },
    {
        path: "/topic/topicList",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/topic/TopicList.vue`)
    },
    {
        path: "/accountZalo/accountList",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/account_zalo/AccountZaloList.vue`)
    },
    {
        path: "/accountZalo/accountList/:id?",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/account_zalo/AccountZaloListReset.vue`)
    },
    {
        path: "/tracking",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/tracking/TrackingZaloList.vue`)
    },
    {
        path: "/trackingMission",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/trackingMission/TrackingMissionList.vue`)
    },
    {
        path: "/tracking/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView1",
        component: () => import(`@/views/admin/tracking/TrackingZaloDetail.vue`)
    },
    {
        path: "/trackingPointInfoLog",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/tracking/TrackingPointInfoLog.vue`)
    },
    {
        path: "/searchLogByPhone",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchByPhoneLog.vue`)
    },
    {
        path: "/kidAccountClass/getLogEA/:id?/:phone?",
        meta: {breadcrumb: true},
        name: "importRequestView1",
        component: () => import(`@/views/admin/infoLog/LogPartPoinInfoLog.vue`)
    },
    {
        path: "/kidAccountClass/getLogMath/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView1",
        component: () => import(`@/views/admin/infoLog/MathPartPoinInfoLog.vue`)
    },
    {
        path: "/import/importPartPoinLog",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportPartPoinLog.vue`)
    },
    {
        path: "/import/importPartPointClassLog",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportPartPointClassLog.vue`)
    },
    {
        path: "/import/importMoveClass",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportMoveClass.vue`)
    },
    {
        path: "/import/getPartPointInfoAccount",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportPartPoin.vue`)
    },
    {
        path: "/searchOderMath",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchOrderMath.vue`)
    },
    {
        path: "/searchOderClass",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchOrderBabiClass.vue`)
    },
    {
        path: "/sendSmsByPhone",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SendSmsByPhone.vue`)
    },
    {
        path: "/getDayVip",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/GetDayVip.vue`)
    },
    {
        path: "/export/exportAccount",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/export/ExportAccountClass.vue`)
    },
    {
        path: "/export/exportLinkBcht",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/export/ExportBchtByAccount.vue`)
    },
    {
        path: "/exportBabiClass/exportAccount",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/exportBabiClass/ExportAccountClass.vue`)
    },
    {
        path: "/exportBabiClass/exportLinkBcht",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/exportBabiClass/ExportBchtByAccount.vue`)
    },
    {
        path: "/getIspeckInfo",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/GetIspeckInfo.vue`)
    },
    {
        path: "/getIspeakInfoByPhone/:phone?",
        meta: {
            public: true
        },
        name: "ForgotPass",
        component: () => import(`@/views/admin/infoLog/GetIspeckInfo.vue`)
    },
    {
        path: "/classWeekProcess",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/week/ClassWeekProcessInfo.vue`)
    },
    {
        path: "/searchAccountPartPoint",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPoint.vue`)
    },
    {
        path: "/searchAccountPartPointV2",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV2.vue`)
    },
    {
        path: "/searchOrderLiveClassPackage",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchOrderLiveClassPacege.vue`)
    },
    {
        path: "/searchAccountPartPointV3",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV3.vue`)
    },
    {
        path: "/searchBabiClassAccountPartPointV3",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchBabiClassAccountPartPointV3.vue`)
    },
    {
        path: "/searchBabiClassOnboarding",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/searchBabiClassOnboarding.vue`)
    },
    {
        path: "/searchAccountPartPointV4",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV4.vue`)
    },
    {
        path: "/searchAccountPartPointV5",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV5.vue`)
    },
    {
        path: "/searchAccountPartPointV6",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV6.vue`)
    },
    {
        path: "/searchAccountPartPointV7",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV7.vue`)
    },
    {
        path: "/getConfigNotifyMKT",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/notifyMKT/NotifyMktList.vue`)
    },
    {
        path: "/getPopupMKT",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/notifyMKT/PopupMktList.vue`)
    },
    {
        path: "/getBundle",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/notifyMKT/BundleList.vue`)
    },
    {
        path: "/searchPhoneMathMHBL",
        meta: {
            breadcrumb: true
        },
        name: "ForgotPass",
        component: () => import(`@/views/admin/infoLog/SearchPhoneMathMHBL.vue`)
    },
    {
        path: "/import/importUrl",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportCreateUrl.vue`)
    },
    {
        path: "/import/assetTheme",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/AssetThemeCreateUrl.vue`)
    },
    {
        path: "/import/importKidGameStory",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/import/ImportKidGameStory.vue`)
    },
    {
        path: "/babiPro/classProList",
        meta: {breadcrumb: true},
        name: "classProlist",
        component: () => import(`@/views/babiPro/ClassBabiProList.vue`)
    },
    {
        path: "/searchScheduleTeacher",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/babiPro/SearchScheduleTeacher.vue`)
    },
    {
        path: "/searchCountDateLear",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/babiPro/SearchCountDateLear.vue`)
    },
    {
        path: "/searchClassProDay",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/babiPro/SearchClassProDay.vue`)
    },
    {
        path: "/classPro/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/babiPro/SchedulesList.vue`)
    },
    {
        path: "/searchKidFreeTime",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/babiPro/TeacherFreeTimeList.vue`)
    },
    //end
    {
        path: "/categorylist/materialTypeAlly",
        meta: {breadcrumb: true},
        name: "materialTypeGroup",
        component: () => import(`@/views/admin/materialTypeAlly/MaterialTypeAllyList.vue`)
    },
    {
        path: "/categorylist/crop",
        meta: {breadcrumb: true},
        name: "crop",
        component: () => import(`@/views/admin/crop/CropList.vue`)
    },
    {
        path: "/categorylist/seedNumber",
        meta: {breadcrumb: true},
        name: "seedNumber",
        component: () => import(`@/views/admin/seed_number/SeedNumberList.vue`)
    },
    {
        path: "/categorylist/officeLocation",
        meta: {breadcrumb: true},
        name: "officeLocation",
        component: () => import(`@/views/admin/office_location/OfficeLocationList.vue`)
    },
    {
        path: "/categorylist/department",
        meta: {breadcrumb: true},
        name: "officeLocation",
        component: () => import(`@/views/admin/department/DepartmentList.vue`)
    },
/*
    {
        path: "/envMeasure",
        meta: {breadcrumb: true},
        name: "envMeasure",
        component: () => import(`@/views/admin/environment/EnvironmentList.vue`)
    },
*/
    {
        path: "/files/create/:procedureId",
        meta: {breadcrumb: true},
        name: "create_file",
        component: () => import(`@/views/files/FileCreate.vue`)
    },
    {
        path: "/procedureWh",
        meta: {breadcrumb: true},
        name: "procedureWh",
        component: () => import(`@/views/admin/procedureWh/ProcedureWhList.vue`)
    },
    {
        path: "/envMeasure",
            meta: {breadcrumb: true},
        name: "envMeasure",
            component: () => import(`@/views/admin/envMeasure/EnvMeasureList.vue`)
    },
    {
        path: "/envG",
            meta: {breadcrumb: true},
        name: "envG",
            component: () => import(`@/views/admin/indexG/GList.vue`)
    },

    {
        path: "/procedureDayList/edit/:id?",
        meta: {breadcrumb: true},
        name: "procedureDayList",
        component: () => import(`@/views/admin/procedureWh/ProcedureWhDayList.vue`)
    },
    {
        path: "/procedureDayList/view/:id?",
        meta: {breadcrumb: true},
        name: "ProcedureWhDayListView",
        component: () => import(`@/views/admin/procedureWh/ProcedureWhDayListView.vue`)
    },
    {
        path: "/requestOrder",
        meta: {breadcrumb: true},
        name: "requestOrder",
        component: () => import(`@/views/admin/request_order/RequestOrderList.vue`)
    },
    {
        path: "/requestOrderDetail/:id?",
        meta: {
            public: true, nomenu: true
        },
        name: "requestOrder",
        component: () => import(`@/views/admin/request_order/RequestOrderCreate.vue`)
    },
    {
        path: "/requestOrder/create",
        meta: {breadcrumb: true},
        name: "requestOrderCreate",
        component: () => import(`@/views/admin/request_order/RequestOrderCreate.vue`)
    },
    {
        path: "/importRequest",
        meta: {breadcrumb: true},
        name: "importRequest",
        component: () => import(`@/views/admin/import_request/ImportRequestList.vue`)
    },
    {
        path: "/importRequest/create/:id?",
        meta: {breadcrumb: true},
        name: "importRequestCreate",
        component: () => import(`@/views/admin/import_request/ImportRequestCreate.vue`)
    },
    {
        path: "/importRequest/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/import_request/ImportRequestView.vue`)
    },
    {
        path: "/importRequest/importWhCreate/:id?",
        meta: {breadcrumb: true},
        name: "importWhCreate",
        component: () => import(`@/views/admin/import_request/ImportWhCreate.vue`)
    },
    {
        path: "/importRequest/importWhView/:id?",
        meta: {breadcrumb: true},
        name: "importWhView",
        component: () => import(`@/views/admin/import_request/ImportWhView.vue`)
    },
    {
        path: "/exportRequest",
        meta: {breadcrumb: true},
        name: "exportRequest",
        component: () => import(`@/views/admin/export_request/ExportRequestList.vue`)
    },
    {
        path: "/exportRequest/create/:id/type/:type",
        meta: {breadcrumb: true},
        name: "exportRequestCreate",
        component: () => import(`@/views/admin/export_request/ExportRequestCreate.vue`)
    },
    {
        path: "/exportRequest/notProcessCreate/:id/type/:type",
        meta: {breadcrumb: true},
        name: "notProcessCreate",
        component: () => import(`@/views/admin/export_request/NotProcessCreate.vue`)
    },
    {
        path: "/exportRequest/notProcessView/:id?",
        meta: {breadcrumb: true},
        name: "notProcessView",
        component: () => import(`@/views/admin/export_request/NotProcessView.vue`)
    },
    {
        path: "/exportRequest/view/:id?",
        meta: {breadcrumb: true},
        name: "exportRequestView",
        component: () => import(`@/views/admin/export_request/ExportRequestView.vue`)
    },
    {
        path: "/exportRequest/view/:id/:in",
        meta: {
            nomenu: true,
            public: true

        },
        name: "exportRequestIn",
        component: () => import(`@/views/admin/export_request/ExportRequestView.vue`)
    },
    {
        path: "/exportRequest/wkView/:id?",
        meta: {breadcrumb: true},
        name: "exportRequestWkView",
        component: () => import(`@/views/admin/export_request/WarehouseKeeperView.vue`)
    },
    {
        path: "/exportRequest/approve/:id?",
        meta: {breadcrumb: true},
        name: "exportRequestApprove",
        component: () => import(`@/views/admin/export_request/ExportRequestApprove.vue`)
    },
    {
        path: "/exportRequest/approve/:areaId/requestDate/:requestDate/status/:status",
        meta: {breadcrumb: true},
        name: "exportRequestApproveAll",
        component: () => import(`@/views/admin/export_request/ExportRequestApprove.vue`)
    },
    {
        path: "/exportRequest/approve/:areaId/requestDate/:requestDate/status/:status/materialTypeAllyId/:materialTypeAllyId",
        meta: {breadcrumb: true},
        name: "exportRequestApproveAll2",
        component: () => import(`@/views/admin/export_request/ExportRequestApprove.vue`)
    },
    {
        path: "/exportRequest/confirm/:areaId/requestDate/:requestDate/status/:status",
        meta: {breadcrumb: true},
        name: "exportRequestConfirmAll",
        component: () => import(`@/views/admin/export_request/ExportRequestApprove.vue`)
    },
    {
        path: "/exportRequest/confirm/:areaId/requestDate/:requestDate/status/:status/materialTypeAllyId/:materialTypeAllyId",
        meta: {breadcrumb: true},
        name: "exportRequestConfirmAll2",
        component: () => import(`@/views/admin/export_request/ExportRequestApprove.vue`)
    },
    {
        path: "/exportRequest/approveNotProcess/:areaId/requestDate/:requestDate/status/:status",
        meta: {breadcrumb: true},
        name: "exportRequestApproveAllNotProcess",
        component: () => import(`@/views/admin/export_request/NotProcessApprove.vue`)
    },
    {
        path: "/exportRequest/approveNotProcess/:areaId/requestDate/:requestDate/status/:status/materialTypeAllyId/:materialTypeAllyId",
        meta: {breadcrumb: true},
        name: "exportRequestApproveAllNotProcess2",
        component: () => import(`@/views/admin/export_request/NotProcessApprove.vue`)
    },
    {
        path: "/exportRequest/confirmNotProcess/:areaId/requestDate/:requestDate/status/:status",
        meta: {breadcrumb: true},
        name: "exportRequestConfirmAllNotProcess",
        component: () => import(`@/views/admin/export_request/NotProcessApprove.vue`)
    },
    {
        path: "/exportRequest/confirmNotProcess/:areaId/requestDate/:requestDate/status/:status/materialTypeAllyId/:materialTypeAllyId",
        meta: {breadcrumb: true},
        name: "exportRequestConfirmAllNotProcess2",
        component: () => import(`@/views/admin/export_request/NotProcessApprove.vue`)
    },
    {
        path: "/exportRequest/summaryView/:areaId/requestDate/:requestDate",
        meta: {breadcrumb: true},
        name: "exportRequestSummaryView",
        component: () => import(`@/views/admin/export_request/ExportRequestSummaryView.vue`)
    },

    {
        path: "/importExportReport",
            meta: {breadcrumb: true},
        name: "importExportReport",
            component: () => import(`@/views/report/ImportExportReport.vue`)
    },

    {
        path: "/print/importExportReport/:print/:warehouseId/:vendorId/:fromDate/:toDate/:form",
        meta: {
            public: true,
            nomenu: true
        },
        name: "PrintImportExportReport",
            component: () => import(`@/views/report/ImportExportReport.vue`)
    },

    {
        path: "/pondReport",
        meta: {breadcrumb: true},
        name: "pondReport",
        component: () => import(`@/views/report/PondReport.vue`)
    },

    {
        path: "/print/pondReport/:print/:areaId/:pondId/:cropId/:fromDate/:toDate",
        meta: {
            public: true,
            nomenu: true
        },
        name: "PrintPondReport",
        component: () => import(`@/views/report/PondReport.vue`)
    },

    {
        path: "/materialReport",
        meta: {breadcrumb: true},
        name: "materialReport",
        component: () => import(`@/views/report/MaterialReport.vue`)
    },

    {
        path: "/ktReport",
        meta: {breadcrumb: true},
        name: "ktReport",
        component: () => import(`@/views/report/KtReport.vue`)
    },

    {
        path: "/print/materialReport/:print/:areaId/:pondId/:cropNo/:year/:fromDate/:toDate",
        meta: {
            public: true,
            nomenu: true
        },
        name: "PrintMaterialReport",
        component: () => import(`@/views/report/MaterialReport.vue`)
    },
    {
        path: "/exportRequestTotalEdit/crop/:cropId?",
        meta: {breadcrumb: true},
        name: "exportRequestTotalEdit",
        component: () => import(`@/views/admin/crop/ExportRequestTotalEdit.vue`)
    },

    {
        path: "/acceptanceReport",
        meta: {breadcrumb: true},
        name: "acceptanceReportList",
        component: () => import(`@/views/admin/acceptance_report/AcceptanceReportList.vue`)
    },
    {
        path: "/acceptanceReport/create/:id",
        meta: {breadcrumb: true},
        name: "acceptanceReportCreate",
        component: () => import(`@/views/admin/acceptance_report/AcceptanceReportCreate.vue`)
    },
    {
        path: "/acceptanceReport/view/:id",
        meta: {breadcrumb: true},
        name: "acceptanceReportView",
            component: () => import(`@/views/admin/acceptance_report/AcceptanceReportView.vue`)
    },
    {
        path: "/category/disease",
        meta: {breadcrumb: true},
        name: "diseaseCategory",
            component: () => import(`@/views/admin/category/diseases/DiseasesList.vue`)
    },
    {
        path: "/notes",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/notes/NoteList.vue`)
    },
    {
        path: "/fixedAssets",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets/FixedAssetsList.vue`)
    },
    {
        path: "/fixedAssetsReport",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets/FixedAssetsReport.vue`)
    },
    {
        path: "/fixedAssets/create",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets/FixedAssetsCreate.vue`)
    },
    {
        path: "/fixedAssets/view",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets/FixedAssetsView.vue`)
    },
    {
        path: "/fixedAssetsTranfer",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets_tranfer/FixedAssetsTranferList.vue`)
    },
    {
        path: "/fixedAssetsTranfer/create",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets_tranfer/FixedAssetsTranferCreate.vue`)
    },
    {
        path: "/fixedAssetsTranfer/view",
        meta: {public: true, nomenu: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets_tranfer/FixedAssetsTranferCreate.vue`)
    },
    {
        path: "/fixedAssetsRepair",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets_repair/FixedAssetsRepairList.vue`)
    },
    {
        path: "/fixedAssetsRepair/create",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets_repair/FixedAssetsRepairCreate.vue`)
    },
    {
        path: "/repairRequest/create",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets_repair/RepairRequestCreateNew.vue`)
    },
    {
        path: "/importRepairRequest/view",
        meta: {breadcrumb: true},
        name: "notes",
            component: () => import(`@/views/admin/fixed_assets_repair/ImportRepairRequestView.vue`)
    },
    {
        path: "/categorylist/assetsName",
        meta: {breadcrumb: true},
        name: "assetsName",
        component: () => import(`@/views/admin/assets_name/AssetsNameList.vue`)
    },
    {
        path: "/searchAccountPartPointV8",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV8.vue`)
    },
    {
        path: "/searchAccountPartPointV9",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointV9.vue`)
    },
    {
        path: "/searchAccountPartPointNophone",
        meta: {breadcrumb: true},
        name: "classlista",
        component: () => import(`@/views/admin/infoLog/SearchAccountPartPointNophone.vue`)
    },
    {
        path: "/searchNotification",
        meta: {breadcrumb: true},
        name: "SearchNotification",
        component: () => import(`@/views/admin/infoLog/SearchNotification.vue`)
    },
    {
        path: "/searchNotificationFinishL1",
        meta: {breadcrumb: true},
        name: "SearchNotificationFinishL1",
        component: () => import(`@/views/admin/infoLog/SearchNotificationFinishL1.vue`)
    },

    {
        path: "/searchLastLogMath",
        meta: {
            breadcrumb: true
        },
        name: "SearchLastLogMath",
        component: () => import(`@/views/admin/infoLog/SearchLastLogMath.vue`)
    },

    {
        path: "/searchLastLogBabiClass",
        meta: {
            breadcrumb: true
        },
        name: "SearchLastLogMath",
        component: () => import(`@/views/admin/infoLog/SearchLastLogBabiClass.vue`)
    },

    {
        path: "/searchAllLogBabiClass",
        meta: {
            breadcrumb: true
        },
        name: "SearchLastLogMath",
        component: () => import(`@/views/admin/infoLog/SearchAllLogBabiClass.vue`)
    },
    {
        path: "/searchAllLogBabiSchool",
        meta: {
            breadcrumb: true
        },
        name: "SearchLastLogMath",
        component: () => import(`@/views/admin/infoLog/SearchAllLogBabiSchool.vue`)
    },
    {
        path: "/searchLessonBabiClass",
        meta: {
            breadcrumb: true
        },
        name: "SearchLessonBabiClass",
        component: () => import(`@/views/admin/infoLog/SearchLessonBabiClass.vue`)
    },
    {
        path: "/countVina",
        meta: {
            breadcrumb: true
        },
        name: "SearchLessonBabiClass",
        component: () => import(`@/views/admin/infoLog/CountVina.vue`)
    },
    {
        path: "/searchCountLogMath",
        meta: {
            breadcrumb: true
        },
        name: "SearchCountLogMath",
        component: () => import(`@/views/admin/infoLog/SearchCountLogMath.vue`)
    },

    {
        path: "/searchTrackingByPhone/:phone?",
        meta: {
            public: true
        },
        name: "SearchTrackingByPhone",
        component: () => import(`@/views/admin/infoLog/SearchTrackingByPhone.vue`)
    },


    {
        path: "/babiProgramFrame/programlist",
        meta: {breadcrumb: true},
        name: "programlist",
        component: () => import(`@/views/admin/babiProgram/ProgramList.vue`)
    },
    {
        path: "/babiProgram/view/:id?",
        meta: {breadcrumb: true},
        name: "babiProgramView",
        component: () => import(`@/views/admin/babiWeek/WeekList.vue`)
    },



    {
        path: "/babiClass/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/babi_class/ClassWeekList.vue`)
    },


    {
        path: "/babiFeedback/view/:id?",
        meta: {breadcrumb: true},
        name: "babiFeedback",
        component: () => import(`@/views/admin/babiPoint/FeedbackList.vue`)
    },
    {
        path: "/babiMissions/view/:id?",
        meta: {breadcrumb: true},
        name: "babiMissions",
        component: () => import(`@/views/admin/babiPoint/MissionReviewList.vue`)
    },
    {
        path: "/babiPartPointInfo/view/:id?",
        meta: {breadcrumb: true},
        name: "babiPartPointInfo",
        component: () => import(`@/views/admin/babiPoint/PartPointList.vue`)
    },

    {
        path: "/babiMissionReview/list",
        meta: {breadcrumb: true},
        name: "babiMissionReview",
        component: () => import(`@/views/admin/babiMissionReview/MissionCheckList.vue`)
    },

    {
        path: "/babiAccountDetailClass/view/:id?",
        meta: {breadcrumb: true},
        name: "babiAccountDetailClass",
        component: () => import(`@/views/admin/babi_account_class/AccountDetail.vue`)
    },


    {
        path: "/babiAccountClass/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView1",
        component: () => import(`@/views/admin/babi_account_class/AccountDetailList.vue`)
    },

    {
        path: "/babiAccount/accountList",
        meta: {breadcrumb: true},
        name: "accountList",
        component: () => import(`@/views/admin/babi_account/AccountList.vue`)
    },


    {
        path: "/babiAccountDetail/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/babi_account/AccountDetail.vue`)
    },
    {
        path: "/babilogModeAccountClass/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/babiModeAccountClass/LogModeClassDetail.vue`)
    },
    {
        path: "/babiClass/classlist",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/babi_class/ClassList.vue`)
    },

    {
        path: "/babiClass/classAccountList",
        meta: {breadcrumb: true},
        name: "classAccountList",
        component: () => import(`@/views/admin/babi_account_class/AccountClassList.vue`)
    },
    {
        path: "/babiImport/importClassZalo",
        meta: {breadcrumb: true},
        name: "classZalolist",
        component: () => import(`@/views/admin/babi_import/ImportClassZaloList.vue`)
    },
    {
        path: "/babiImport/importMission",
        meta: {breadcrumb: true},
        name: "missionlist",
        component: () => import(`@/views/admin/babi_import/ImportMissionList.vue`)
    },

    {
        path: "/babiAccountZalo/accountList",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/babi_account_zalo/AccountZaloList.vue`)
    },
    {
        path: "/babiAccountZalo/accountList/:id?",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/babi_account_zalo/AccountZaloListReset.vue`)
    },
    {
        path: "/babiTracking",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/babi_tracking/TrackingZaloList.vue`)
    },
    {
        path: "/babiTrackingMission",
        meta: {breadcrumb: true},
        name: "babiTrackingMission",
        component: () => import(`@/views/admin/babiTrackingMission/TrackingMissionList.vue`)
    },
    {
        path: "/babiTracking/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView1",
        component: () => import(`@/views/admin/babi_tracking/TrackingZaloDetail.vue`)
    },
    {
        path: "/babiTrackingPointInfoLog",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/babi_tracking/TrackingPointInfoLog.vue`)
    },
    {
        path: "/babiImport/importMoveClass",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/babi_import/ImportMoveClass.vue`)
    },

    {
        path: "/babiClassWeekProcess",
        meta: {breadcrumb: true},
        name: "babiClassWeekProcess",
        component: () => import(`@/views/admin/babiWeek/ClassWeekProcessInfo.vue`)
    },

    {
        path: "/babiTopic/topicList",
        meta: {breadcrumb: true},
        name: "classlist",
        component: () => import(`@/views/admin/babi_topic/TopicList.vue`)
    },

    {
        path: "/babiPartPointInfoAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "babiPartPointInfoAccount",
        component: () => import(`@/views/admin/babiclass_point_account/PartPointList.vue`)
    },



    {
        path: "/babiLiveClassPointInfoAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "babiLiveClassPointInfoAccount",
        component: () => import(`@/views/admin/babiclass_point_account/LiveClassList.vue`)
    },

    {
        path: "/babiCategoryPointInfoAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "babiCategoryPointInfoAccount",
        component: () => import(`@/views/admin/babiclass_point_account/CategoryPointList.vue`)
    },


    {
        path: "/babiLiveClassPointInfo/view/:id?",
        meta: {breadcrumb: true},
        name: "babiLiveClassPointInfo",
        component: () => import(`@/views/admin/babiclass_point/LiveClassList.vue`)
    },

    {
        path: "/babiCategoryPointInfo/view/:id?",
        meta: {breadcrumb: true},
        name: "importRequestView",
        component: () => import(`@/views/admin/babiclass_point/CategoryPointList.vue`)
    },
    {
        path: "/babiFeedbackAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "babiFeedbackAccount",
        component: () => import(`@/views/admin/babiclass_point_account/FeedbackList.vue`)
    },
    {
        path: "/babiMissionsAccount/view/:id?",
        meta: {breadcrumb: true},
        name: "babiMissionsAccount",
        component: () => import(`@/views/admin/babiclass_point_account/MissionReviewList.vue`)
    },

    {
        path: "/schoolClass/list",
        meta: {breadcrumb: true},
        name: "schoolClass",
        component: () => import(`@/views/admin/school_class/SchoolClassList.vue`)
    },

    {
        path: "/schoolClass/generalClassReport",
        meta: {breadcrumb: true},
        name: "schoolClass",
        component: () => import(`@/views/admin/school_class/SchoolGeneralClassReport.vue`)
    },
    {
        path: "/schoolClass/reportlist",
        meta: {breadcrumb: true},
        name: "schoolClass",
        component: () => import(`@/views/admin/school_class/SchoolClassListReport.vue`)
    },
    {
        path: "/schoolClass/reportlist/:fromDate?/:toDate?",
        meta: {breadcrumb: true},
        name: "schoolClass",
        component: () => import(`@/views/admin/school_class/SchoolClassListReport.vue`)
    },
    {
        path: "/schoolClass/reportlist/view/:id?/:fromDate?/:toDate?",
        meta: {breadcrumb: true},
        name: "schoolClass",
        component: () => import(`@/views/admin/school_class/SchoolClassListReportView.vue`)
    },
    {
        path: "/schoolRoundGame/list",
        meta: {breadcrumb: true},
        name: "schoolRoundGame",
        component: () => import(`@/views/admin/school_round_game/SchoolRoundGameList.vue`)
    },
    {
        path: "/schoolGameTutorial/list",
        meta: {breadcrumb: true},
        name: "schoolGameTutorial",
        component: () => import(`@/views/admin/school_game_tutorial/SchoolGameTutorialList.vue`)
    },
    {
        path: "/schoolTutorial/list",
        meta: {breadcrumb: true},
        name: "schoolTutorial",
        component: () => import(`@/views/admin/school_tutorial/SchoolTutorialList.vue`)
    },
    {
        path: "/schoolPartStickerBg/list",
        meta: {breadcrumb: true},
        name: "schoolPartStickerBg",
        component: () => import(`@/views/admin/school_part_sticker_bg/SchoolPartStickerBgList.vue`)
    },
    {
        path: "/schoolGameStory/list",
        meta: {breadcrumb: true},
        name: "schoolGameStory",
        component: () => import(`@/views/admin/school_game_story/SchoolGameStoryList.vue`)
    },
    {
        path: "/schoolLessonPlan/list",
        meta: {breadcrumb: true},
        name: "schoolGameStory",
        component: () => import(`@/views/admin/school_lesson_plan/SchoolLessonPlanList.vue`)
    },
    {
        path: "/schoolLessonPlan/listView",
        meta: {breadcrumb: true},
        name: "schoolGameStory",
        component: () => import(`@/views/admin/school_lesson_plan/SchoolLessonPlanListView.vue`)
    },

    {
        path: "/schoolLessonPlanEduSmart/listView",
        meta: {breadcrumb: true},
        name: "schoolGameStory",
        component: () => import(`@/views/admin/school_lesson_plan_edu_smart/SchoolLessonPlanListView.vue`)
    },

    {
        path: "/schoolAccount/edit",
        meta: {breadcrumb: true},
        name: "schoolGameStory",
        component: () => import(`@/views/admin/school_account/SchoolAccountEdit.vue`)
    },
    {
        path: "/SchoolHomeInfo",
        meta: {breadcrumb: true},
        name: "SchoolHomeInfo",
        component: () => import(`@/views/admin/school/SchoolHomeInfo.vue`)
    },
    {
        path: "/SchoolHomePeriodInfo",
        meta: {breadcrumb: true},
        name: "SchoolHomeInfo",
        component: () => import(`@/views/admin/school/SchoolHomePeriodInfo.vue`)
    },
    {
        path: "/importSchool/importData",
        meta: {breadcrumb: true},
        name: "importDataSchool",
        component: () => import(`@/views/admin/importSchool/ImportSchoolList.vue`)
    },
    {
        path: "/importSchool/importSchoolClass",
        meta: {breadcrumb: true},
        name: "importSchoolClass",
        component: () => import(`@/views/admin/importSchool/ImportSchoolClass.vue`)
    },
    {
        path: "/schoolClass/schedule",
        meta: {breadcrumb: true},
        name: "importDataSchool",
        component: () => import(`@/views/admin/school_class/SchoolClassSchedule.vue`)
    },

    {
        path: "/deleteLogBabi",
        meta: {
            breadcrumb: true
        },
        name: "deleteLogBabi",
        component: () => import(`@/views/admin/log/deleteLogBabi.vue`)
    },

    {
        path: "/deleteLogMath",
        meta: {
            breadcrumb: true
        },
        name: "deleteLogMath",
        component: () => import(`@/views/admin/log/deleteLogMath.vue`)
    },


    {
        path: "/progress-report",
        meta: {breadcrumb: true},
        name: "ProgressReport",
        component: () => import(`@/views/report/ProgressReport.vue`)
    },

    {
        path: "/speaking-video",
        meta: {breadcrumb: true},
        name: "SpeakingVideoList",
        component: () => import(`@/views/speakingVideo/SpeakingVideoList.vue`)
    },
    {
        path: "/videoPlayer",
        meta: {
            public: true
        },
        name: "SpeakingVideoDetail",
        component: () => import(`@/views/speakingVideo/SpeakingVideoDetail.vue`)
    },
    {
        path: "/genCode",
        meta: {public:true},
        name: "GenCodePage",
        component: () => import(`@/views/genCode/GenCodePage.vue`)
    }
];
